import { render, staticRenderFns } from "./CustomDelete.vue?vue&type=template&id=fb532d32&"
import script from "./CustomDelete.vue?vue&type=script&lang=js&"
export * from "./CustomDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports